import React from 'react';
import PowerfuelHero from '@/components/powerfuel/PowerfuelHero';
import PowerfuelProduct from '@/components/powerfuel/PowerfuelProduct';
import PowerfuelAconto from '@/components/powerfuel/PowerfuelAconto';
import PowerfuelEvPerks from '@/components/powerfuel/PowerfuelEvPerks';
import VelkommenSavingsComparison from '@/components/velkommen/VelkommenSavingsComparison';
import VelkommenSwitchProducts from '@/components/velkommen/VelkommenSwitchProducts';
import VelkommenInfo from '@/components/velkommen/VelkommenInfo';
import VelkommenRights from '@/components/velkommen/VelkommenRights';
import VelkommenFAQ from '@/components/velkommen/VelkommenFAQ';
import VelkommenEVSignup from '@/components/velkommen/VelkommenEVSignup';
import VelkommenFooterRights from '@/components/velkommen/VelkommenFooterRights';
import { BreadcrumbSchema } from '@/components/JsonLd';

export default function PowerfuelVelkommen() {
  return (
    <div style={{ fontFamily: '"DM Sans", "Space Grotesk", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <BreadcrumbSchema items={[
        { name: 'Forside', path: '/' },
        { name: 'Velkommen Powerfuel-kunder', path: '/powerfuel' }
      ]} />
      <PowerfuelHero />
      <PowerfuelProduct />
      <PowerfuelAconto />
      {/* EV focus first — Powerfuel customers are EV owners. */}
      <PowerfuelEvPerks />
      <VelkommenSavingsComparison />
      <VelkommenSwitchProducts />
      {/* Same regulatory detail, rights and FAQ as the general welcome page. */}
      <VelkommenInfo />
      <VelkommenRights />
      <VelkommenFAQ />
      <VelkommenEVSignup />
      <VelkommenFooterRights />
    </div>
  );
}